// itinerarySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Url } from "./url";

export const fetchConfiguration = createAsyncThunk(
  "configuration/fetchConfiguration",
  async (chainCode, rejectWithValue) => {
    try {
      const response = await axios.get(
        `${Url}/be/Config?chainCode=${chainCode}`
      );
      return response.data; // Assuming the API response format is { data: [...] }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const configurationSlice = createSlice({
  name: "configuration",
  initialState: {
    configuration: {},
    loading: false, // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfiguration.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.configuration = action.payload;
      })
      .addCase(fetchConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default configurationSlice.reducer;
